import { Numeric8CircleOutlineIcon } from './Numeric8CircleOutlineIcon';

/**
 * author: Contributors
 * id C1306EC5-E7F0-4152-A19D-84E851537171
 * name numeric-8-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-8-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericEightCircleOutlineIcon = Numeric8CircleOutlineIcon;
export default NumericEightCircleOutlineIcon